<template>
  <van-tabs v-model="active" @click="onClick">
    <van-tab title="提现记录">
      <div class="goods-list">
        <div
          v-for="(item, index) in withdrawList"
          :key="index"
          class="goods-item d-flex flex-row justify-content-between align-items-center"
        >
          <div class="flex-1 d-flex flex-column">
            <div style="font-size: 14px">{{ item.bankNo }}</div>
            <div style="font-size: 14px" class="timeStr">
              ￥
              {{ item.drawAmount }}
            </div>
          </div>
          <div v-if="item.status === 0">提现中</div>
          <div v-if="item.status === 1">提现成功</div>
          <div
            v-if="item.status === 2"
            class="d-flex flex-column align-items-center"
          >
            提现失败<span style="color: #909399; font-size: 14px"
              >原因:{{ item.reason }}</span
            >
          </div>
        </div>
      </div>
    </van-tab>
    <van-tab title="收入记录">
      <div class="goods-list">
        <div
          v-for="(item, index) in incomeList"
          :key="index"
          class="goods-item d-flex flex-row justify-content-between align-items-center"
        >
          <div class="flex-1 d-flex flex-column">
            <div style="font-size: 14px">{{ item.customerMemberName }}</div>
            <div style="font-size: 14px" class="timeStr">
              {{ item.orderNo }}
            </div>
          </div>
          <div>￥{{ item.commission }}</div>
        </div>
      </div>
    </van-tab>
  </van-tabs>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      withdrawList: [],
      incomeList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList(page, size) {
      let params = {
        page: 1,
        size: 20,
      };
      this.$http
        .request(this.$http.pathMap.withDrawList, "post", params)
        .then((res) => {
          let data = res.data;
          this.withdrawList = data.result;
        });
    },
    getincomeList() {
      let params = {
        page: 1,
        size: 20,
      };
      this.$http
        .request(this.$http.pathMap.commissionRecord, "post", params)
        .then((res) => {
          let data = res.data;
          this.incomeList = data.result;
        });
    },
    onClick(title) {
      if (title === 0) {
        this.getList();
      } else {
        this.getincomeList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.goods-list {
  padding: 0 15px;
  background: #fff;
  .goods-item {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 5px 10px;
    border-bottom: 1px rgba(230, 230, 230, 1) solid;
    .timeStr {
      color: $font-color-light;
      font-size: $uni-font-size-lg;
    }
  }
}
</style>
